jQuery(document).ready(function ($) {
    $(".qwrapper").click(function () {
        $(this).children(".answer").toggleClass("visible");
    });
});
